import numeral from "numeral";
import { NumberFormat } from "../../Enums/constants";

/**
 * Formats a value with numeral depending on the formatType
 * @param formatType constants.js/NumberFormat
 * @param value 
 * @returns {string|*} formatted number as string
 */
export function formatNumber(formatType, value) {
    if (value === undefined || value === null || value === "") {
        return "";
    }
    // Force the value into a number object, otherwise, numeral cannot handle it correctly
    if (typeof (value) !== "number") {
        value = Number(value);
    }

    if (Number.isNaN(value)) {
        return "N/A";
    }
    let sign = Math.sign(value)
    // TODO need to test most of these....
    let returnVal;
    value = Math.abs(value)
    if (formatType === NumberFormat.DECIMAL1)
        returnVal = numeral(value).format("0,0.0");
    else if (formatType === NumberFormat.DECIMAL2)
        returnVal = numeral(value).format("0,0.00");
    else if (formatType === NumberFormat.INTEGER)
        returnVal = numeral(value).format("0,0");
    else if (formatType === NumberFormat.YEAR)
        returnVal = numeral(value).format("0");
    else if (formatType === "money")
        returnVal = numeral(value).format("$0,0.00");
    else if (formatType === "moneydecimal1")
        returnVal = numeral(value).format("$0,0.0");
    else if (formatType === NumberFormat.MONEYINTEGER)
        returnVal = numeral(value).format("$0,0")
    else if (formatType === NumberFormat.MONEYTHOUSAND)
        returnVal = numeral(value).format("$0,00.0") + " K"
    else if (formatType === NumberFormat.MONEYMILLION)
        returnVal = numeral(value).format("$0,00.0") + " M"
    else if (formatType === NumberFormat.MONEYBILLION)
        returnVal = numeral(value).format("$0,00.0") + " B"
    else if (formatType === NumberFormat.PERCENTAGE || formatType === NumberFormat.PERCENTAGE_UK)
        returnVal = numeral(value / 100).format("%0.0");
    else if (formatType === NumberFormat.PERCENTAGEINTEGER)
        returnVal = numeral(value / 100).format("%0");
    else if (formatType === "thousand")
        returnVal = numeral(value / 1000).format("0,0.00") + "k";
    else if (formatType === "million")
        returnVal = numeral(value / 1000000).format("0,0.00") + "m";
    else if (formatType === "billion")
        returnVal = numeral(value / 1000000000).format("0,0.00") + "b";
    else if (formatType === NumberFormat.NONE)
        returnVal = numeral(value).value();
    else if (formatType === NumberFormat.BPSDECIMAL1)
        returnVal = numeral(value).format("0,0.0") + " bps"
    else if (formatType === NumberFormat.BPSDECIMAL2)
        returnVal = numeral(value).format("0,0.00") + " bps"
    else if (formatType === NumberFormat.BPSINTEGER)
        returnVal = numeral(value).format("0,0") + " bps"
    else
        returnVal = numeral(value).format("0,0");
    if (sign == -1) returnVal = "(" + returnVal + ")"
    return returnVal;
}
